import * as dc from "@/components/layout/list/defaultType";
import { ClipboardProp, DataListParams, DataListProp, DataParams, LayoutProps } from "../../layoutType";
import { runFormFunction } from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { getSelectPageUserAuth } from "@/util/authutil";
import { enLocale } from "@/i18n/routing";
export const RoasterEtc = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;

  const utcOffset = dayjs().utcOffset() * 60000;
  const select_user_auth = getSelectPageUserAuth(params, "roaster")?.user_auth;
  Debug(select_user_auth);

  switch (params?.page.page ?? "") {
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roaster_user","system_table_pk":["roaster_seq","roaster_user_seq"],"system_table_page":"RoasterUser","system_table_path":"roaster/user/list","system_table_page_name":"RoasterUser","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"SMNG","system_table_mapper":"roasteruser","system_table_detail_result":"detail_result","system_table_search_column":["roaster_user_auth","roaster_user_use"],"system_table_search_select":["roaster_user_name","roaster_user_nick"],"system_table_order_column":["roaster_user_auth","roaster_user_nick","roaster_user_name","rgst_at"],"system_table_default_name_column":"roaster_user_name","system_table_use_column":"roaster_user_use"}
    //--info--}

    case "RoasterUser":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/user/list/detail/", saveFetch: { fetchUrl: "/api/roaster/user/list/edit" } },
        listFetch: { fetchUrl: "/api/roaster/user/list/list" },
        dataResultName: "detail_result",
        dataName: "RoasterUserData",
        editCheck: true,
        editReload: true,
        writeButton: false,
        dataCols: {
          // roaster_seq: { ...dc.seq, required: true },
          // roaster_user_seq: { ...dc.seq, required: true },
          // roaster_user_uuid: { ...dc.input },
          roaster_user_nick: { ...dc.input, maxLength: 100, showCount: true, disabled: true },
          // roaster_user_level: { ...dc.number },
          roaster_user_auth: {
            ...dc.select,
            codeGroup: "RAUTH",
            maxLength: 300,
            showCount: true,
            update: {
              selectFilter: {
                code_id: select_user_auth === "OWN" ? ["ROASTER", "SAST", "MNG", "SMNG", "FIRE"] : ["ROASTER", "SAST", "MNG", "FIRE"],
              },
            },
          },
          roaster_user_desc: { ...dc.textAreaM, readOnly: true },
          roaster_user_use: { ...dc.useDefault, disabled: true, read: { display: false } },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        listColLinkField: "roaster_user_uuid",
        base64Field: ["roaster_user_uuid"],
        listSearch: [
          {
            ...dc.select,
            field: "search0",
            codeGroup: "RAUTH",
            label: "roaster_user_auth",
            placeholder: "roaster_user_auth",
            selectFilter: {
              code_id: ["ROASTER", "SAST", "MNG", "SMNG", "OWN"],
            },
          },
          { ...dc.listSearchUse, field: "search1", label: "roaster_user_use", placeholder: "roaster_user_use" },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "roaster_user_nick", placeholder: "roaster_user_nick" },
          // { ...dc.input, field: "search_type1", label: "roaster_user_nick", placeholder: "roaster_user_nick" },
        ],
        listOrder: [
          "roaster_user_auth_orderdesc",
          "roaster_user_auth_orderasc",
          "roaster_user_nick_orderdesc",
          "roaster_user_nick_orderasc",
          "rgst_at_orderdesc",
          "rgst_at_orderasc",
        ],
        listCols: [
          // "roaster_seq",
          // "roaster_user_seq",
          //"roaster_user_uuid",
          "roaster_user_nick",
          //"roaster_user_level",
          { field: "roaster_user_auth", codeGroup: "RAUTH" },
          { field: "roaster_user_use", ...dc.listUse },
          { field: "rgst_at", ...dc.datetime, dateFormatter: "YYYY-MM-DD" },
        ],
      };

    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"event_list","system_table_pk":["roaster_seq","event_year","event_seq"],"system_table_manual_increment":"event_seq","system_table_page":"RoasterEvent","system_table_path":"roaster/event","system_table_page_name":"RoasterEvent","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"MNG","system_table_mapper":"roasterevent","system_table_detail_result":"detail_result","system_table_search_column":["event_type"],"system_table_search_select":["event_name_locale","event_name"],"system_table_order_column":["event_end","event_start","event_name_locale"],"system_table_default_name_column":"event_name_locale","system_table_en_name_column":"event_name"}
    //--info--}
    case "RoasterEvent":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/event/detail/", saveFetch: { fetchUrl: "/api/roaster/event/edit" } },
        listFetch: { fetchUrl: "/api/roaster/event/list" },
        dataResultName: "detail_result",
        dataName: "RoasterEventData",
        editCheck: true,
        dataCols: {
          event_year: { ...dc.seqYear, required: true, inputClassName: dc.inputNumberWidth, disabled: true },
          event_start: {
            ...dc.datetime,
            labelClassName: dc.strongLabelClassName,
            // dateFormatter: "YYYY-MM-DD A HH:mm",
            // dateProp: { minuteStep: 10, showSecond: false },
            required: true,
            onChange: (e) => {
              const event_type = form?.current?.getFieldValue("event_type");
              const event_term = form?.current?.getFieldValue("event_term") ?? 3;
              Debug(params, event_type, e);
              if (e.value) {
                const dataMode = dataFunction?.current["getDataMode"] ? dataFunction?.current["getDataMode"]() : undefined;
                if (dataMode === "write") {
                  form?.current?.setFieldValue("event_year", e.value);
                  if (event_type === "SGNP") {
                    form?.current?.setFieldValue("event_end", dayjs(e.value).add(event_term, "day"));
                  } else {
                    form?.current?.setFieldValue("event_end", dayjs(e.value).add(event_term, "day"));
                  }
                }
              } else {
                form?.current?.setFieldValue("event_end", undefined);
              }
            },
          },
          event_end: {
            ...dc.datetime,
            labelClassName: dc.strongLabelClassName,
            // dateFormatter: "YYYY-MM-DD A HH:mm",
            // dateProp: { minuteStep: 10, nowButton: false, showSecond: false },

            required: true,
          },
          event_type: {
            ...dc.select,
            labelClassName: dc.strongLabelClassName,
            inputClassName: dc.inputNumberWidth,
            codeGroup: "EVNT",
            required: true,
            minLength: 3,
            maxLength: 45,
            showCount: true,
            create: { defaultValue: "SGNP" },
            dataProp: {
              load: (data, value_data, field, index, change) => {
                if (value_data && value_data.code_id) {
                  Debug(value_data.code_id);
                  switch (value_data.code_id) {
                    case "CSTMR":
                      runFormFunction(formFunction?.current, "event_uuid", "setQRPathName", "/cafe/supplier/roasterregister/");
                      break;
                  }
                }
              },
            },
          },
          event_term: {
            ...dc.number,
            clearProp: { clearButton: true },
            minValue: 0,
            maxValue: 31,
            create: { display: true, defaultValue: 3, inputClassName: dc.inputNumberWidth + " text-last" },
            update: { display: false },
            read: { display: false },
            placeholder: "event_term",
            unit: { element: "day_unit", transition: true },
            saveData: false,
            onChange: (e) => {
              // Debug(e.value);
              const event_start = form?.current?.getFieldValue("event_start");
              if (event_start) {
                form?.current?.setFieldValue("event_end", dayjs(event_start).add(e.value, "day"));
              }
            },
          },
          // event_seq: { ...dc.seq, required: true, disabled: true },
          // event_uuid: { ...dc.input, required: true },
          event_name_locale: { ...dc.inputFull, maxLength: 300, showCount: true, read: { display: "notNull" } },
          event_name: { ...dc.inputFull, maxLength: 300, showCount: true, read: { display: "notNull" } },
          event_status: {
            ...dc.eventStatus,
            edit: { display: false },
          },
          event_uuid: {
            ...dc.qrcode,
            read: { display: "false", displayCheckIds: ["event_status"] },
            linkOption: { pathname: "/user/link/roastersignup/" },
          },
          event_desc: { ...dc.textAreaDefault, maxLength: 3000, showCount: true },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        listColLinkField: ["event_year", "event_seq"],
        listSearch: [{ ...dc.select, codeGroup: "EVNT", field: "search0", label: "event_type", placeholder: "event_type" }],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "event_name_locale", placeholder: "event_name_locale" },
          // { ...dc.input, field: "search_type0", label: "event_name_locale", placeholder: "event_name_locale" },
          // { ...dc.input, field: "search_type1", label: "event_name", placeholder: "event_name" },
        ],
        listOrder: [
          "event_end_orderdesc",
          "event_end_orderasc",
          "event_start_orderdesc",
          "event_start_orderasc",
          "event_name_locale_orderdesc",
          "event_name_locale_orderasc",
        ],
        listCols: [
          // "roaster_seq",
          "event_year",
          // "event_seq",
          //"event_uuid",
          { field: "event_start", ...dc.datetime, dateFormatter: "MM-DD A hh:mm" },
          { field: "event_end", ...dc.datetime, dateFormatter: "YYYY-MM-DD A hh:mm" },
          { field: "event_status", ...dc.eventStatus },
          params?.locale === enLocale ? "event_name" : "event_name_locale",
          { field: "event_type", codeGroup: "EVNT" },
        ],
      };

    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roaster_user","system_table_pk":["roaster_seq","roaster_user_seq"],"system_table_page":"RoasterUserSignUp","system_table_path":"roaster/user/signup","system_table_page_name":"RoasterUserSignUp","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"SMNG","system_table_mapper":"roasteruser","system_table_detail_result":"detail_result","system_table_search_column":["roaster_user_auth","roaster_user_use"],"system_table_search_select":["roaster_user_name","roaster_user_nick"],"system_table_order_column":["roaster_user_auth","roaster_user_nick","roaster_user_name","rgst_at"],"system_table_default_name_column":"roaster_user_name","system_table_use_column":"roaster_user_use"}
    //--info--}

    case "RoasterUserSignUp":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/user/signup/detail/", saveFetch: { fetchUrl: "/api/roaster/user/signup/edit" } },
        listFetch: { fetchUrl: "/api/roaster/user/signup/list" },
        dataResultName: "detail_result",
        dataName: "RoasterUserSignUpData",
        editCheck: true,
        writeButton: false,
        dataCols: {
          // roaster_seq: { ...dc.seq, required: true },
          // roaster_user_seq: { ...dc.seq, required: true },
          // roaster_user_uuid: { ...dc.input },
          roaster_user_nick: { ...dc.input, maxLength: 100, showCount: true, disabled: true },
          // roaster_user_level: { ...dc.number },
          roaster_user_auth: {
            ...dc.select,
            codeGroup: "RAUTH",
            maxLength: 300,
            showCount: true,
            selectFilter: {
              code_id: ["ROASTER", "WTSGNP", "HLD", "CNCL", "RJCT"],
            },
          },
          roaster_user_desc: { ...dc.textAreaM },
          roaster_user_use: { ...dc.useDefault, disabled: true, read: { display: false } },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        listColLinkField: "roaster_user_uuid",
        base64Field: ["roaster_user_uuid"],
        listSearch: [
          {
            ...dc.select,
            field: "search0",
            codeGroup: "RAUTH",
            label: "roaster_user_auth",
            placeholder: "roaster_user_auth",
            selectFilter: {
              code_id: ["WTSGNP", "HLD"],
            },
          },
          { ...dc.listSearchUse, field: "search1", label: "roaster_user_use", placeholder: "roaster_user_use" },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "roaster_user_nick", placeholder: "roaster_user_nick" },
          // { ...dc.input, field: "search_type1", label: "roaster_user_nick", placeholder: "roaster_user_nick" },
        ],
        listOrder: [
          "rgst_at_orderdesc",
          "rgst_at_orderasc",
          "roaster_user_auth_orderdesc",
          "roaster_user_auth_orderasc",
          "roaster_user_nick_orderdesc",
          "roaster_user_nick_orderasc",
        ],
        listCols: [
          // "roaster_seq",
          // "roaster_user_seq",
          //"roaster_user_uuid",
          "roaster_user_nick",
          //"roaster_user_level",
          { field: "roaster_user_auth", codeGroup: "RAUTH" },
          { field: "roaster_user_use", ...dc.listUse },
          { field: "rgst_at", ...dc.datetime, dateFormatter: "YYYY-MM-DD" },
        ],
      };

    case "RoasterUserEtc":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/user/etc/detail/", saveFetch: { fetchUrl: "/api/roaster/user/etc/edit" } },
        listFetch: { fetchUrl: "/api/roaster/user/etc/list" },
        dataResultName: "detail_result",
        dataName: "RoasterUserEtcData",
        editCheck: true,
        writeButton: false,
        dataCols: {
          // roaster_seq: { ...dc.seq, required: true },
          // roaster_user_seq: { ...dc.seq, required: true },
          // roaster_user_uuid: { ...dc.input },
          roaster_user_nick: { ...dc.input, maxLength: 100, showCount: true, disabled: true },
          // roaster_user_level: { ...dc.number },
          roaster_user_auth: {
            ...dc.select,
            codeGroup: "RAUTH",
            maxLength: 300,
            showCount: true,
            selectFilter: {
              code_id: ["CNCL", "RJCT", "RJN", "FIRE"],
            },
          },
          roaster_user_desc: { ...dc.textAreaM, readOnly: true },
          roaster_user_use: { ...dc.useDefault, disabled: true, read: { display: false } },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        listColLinkField: "roaster_user_uuid",
        base64Field: ["roaster_user_uuid"],
        listSearch: [
          {
            ...dc.select,
            field: "search0",
            codeGroup: "RAUTH",
            label: "roaster_user_auth",
            placeholder: "roaster_user_auth",
            selectFilter: {
              code_id: ["CNCL", "RJCT", "RJN", "FIRE"],
            },
          },
          { ...dc.listSearchUse, field: "search1", label: "roaster_user_use", placeholder: "roaster_user_use" },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "roaster_user_nick", placeholder: "roaster_user_nick" },
          // { ...dc.input, field: "search_type1", label: "roaster_user_nick", placeholder: "roaster_user_nick" },
        ],
        listOrder: [
          "rgst_at_orderdesc",
          "rgst_at_orderasc",
          "roaster_user_auth_orderdesc",
          "roaster_user_auth_orderasc",
          "roaster_user_nick_orderdesc",
          "roaster_user_nick_orderasc",
        ],
        listCols: [
          // "roaster_seq",
          // "roaster_user_seq",
          //"roaster_user_uuid",
          "roaster_user_nick",
          //"roaster_user_level",
          { field: "roaster_user_auth", codeGroup: "RAUTH" },
          { field: "roaster_user_use", ...dc.listUse },
          { field: "rgst_at", ...dc.datetime, dateFormatter: "YYYY-MM-DD" },
        ],
      };

    default:
      return undefined;
  }
};
